import React from "react";
import PropTypes from "prop-types";
import ModalConfirm from "./modal-confirm";

const ModalDestroyConfirm = props => {
  return (
    <ModalConfirm style={{ width: "384px" }} type="destroy" saveLabel="OK" header="Are you sure?" hasMargin {...props}>
      {props.children ? props.children : <div>Are you sure you want to delete ${props.itemToDelete || "this"}?</div>}
    </ModalConfirm>
  );
};

ModalDestroyConfirm.propTypes = {
  itemToDelete: PropTypes.string,
};

export default ModalDestroyConfirm;
